export default {
  All: "Tümü",
  Search: "Ara",
  Transfer: "Transfer",
  AgentDirect: " Agent (Çaldır)",
  AgentQueue: "Agent (Kuyruk)",
  Queue: "Kuyruk",
  PleaseWait: "Lütfen Bekleyin",
  TransferHoldAgent: "Görüntülü görüşme transferi yapılıyor. Lütfen bekleyin.",
  TransferHoldAgentDetail:
    "Eğer transfer işlemi diğer agent tarafından kabul edilmezse, aşağıdaki butona tıklayarak görüşmeye devam edebilirsiniz.",
  TransferHoldUser: "Görüntülü görüşmeniz transfer ediliyor. Lütfen bekleyin.",
  TransferHoldUserDetail: "Çağrınız birazdan aktarılacak..",

  TransferBridgeNull: "Transferi yönetebilecek bir bağlantı bulunmamaktadır.",
};
